import { render } from "./GoalStartDateActivity.vue?vue&type=template&id=38f3e88a"
import script from "./GoalStartDateActivity.vue?vue&type=script&lang=js"
export * from "./GoalStartDateActivity.vue?vue&type=script&lang=js"
script.render = render

export default script